import DeltaCounts from "components/DeltaCounts";
import TableCellEmpty from "ds/components/Table/Row/CellEmpty";
import TableSimpleCell from "ds/components/TableSimple/Cell";

import { StackPullRequestsTableRunCellProps } from "../types";

const StackPullRequestsTableRunDeltaCell = ({
  item: { run },
  isAnsible,
  ...cellProps
}: StackPullRequestsTableRunCellProps) => {
  return (
    <TableSimpleCell {...cellProps}>
      {!run.delta && <TableCellEmpty />}

      {!!run.delta && (
        <DeltaCounts
          size="small"
          align="start"
          variant="flexible"
          direction="column"
          delta={run.delta}
          isAnsible={isAnsible}
        />
      )}
    </TableSimpleCell>
  );
};

export default StackPullRequestsTableRunDeltaCell;
